import { render, staticRenderFns } from "./DialogPageFace.vue?vue&type=template&id=b7af0aac&scoped=true&"
import script from "./DialogPageFace.vue?vue&type=script&lang=js&"
export * from "./DialogPageFace.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageFace.vue?vue&type=style&index=0&id=b7af0aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af0aac",
  null
  
)

export default component.exports